<template>
    <div v-for="references in theme">
        <CodeArticle :references>

        </CodeArticle>
    </div>

</template>
<script setup>

import {onMounted,computed, ref, watch} from 'vue'

import CodeArticle from './CodeArticle.vue';
const props= defineProps({
    theme:Object
  })

</script>